<template>
  <nav class="disciplines">
    <ul v-if="disciplines">
      <li>
        <button @click="pickDiscipline(null)">Alles</button>
      </li>
      <li v-for="(item, index) in disciplines" v-bind:key="index">
        <button @click="pickDiscipline(item.id)"
          :class="{active: active === item.id}">
          {{item.name}} ({{item.count}})</button>
      </li>
    </ul>
  </nav>
</template>

<script>
// import { settings } from '../variables.js'

export default {
  data () {
    return {
      active: null
    }
  },
  beforeCreate: function () {
    if (!this.$store.state.projectsModule.disciplines) {
      this.$store.dispatch('projectsModule/getDisciplines')
    }
  },
  methods: {
    pickDiscipline: function (id) {
      this.active = id
      this.$emit('update:discipline', id)
    }
  },
  computed: {
    disciplines () {
      return this.$store.state.projectsModule.disciplines
    }
  }
}
</script>

<style lang="scss">
  nav.disciplines {
    width: 100%;
    padding: 0 10px;
    font-size: 0.8em;

    @media all and (min-width: 1024px) {
      padding: 0;
      font-size: 1em;
    }

    ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      list-style: none;
      width: 100%;
      margin: 1em -5px;
      padding-left: 0;

      li {
        margin: 5px;
      }

      button {
        appearance: none;
        background-color: #ffffff;
        color: #2c3e50;
        font-size: 1em;
        font-family: nudista-web, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        border: 0;
        padding: 6px 14px;
        cursor: pointer;
        outline: none;

        &:hover {
          background-color: #86ff00;
        }
        &.active {
          background-color: #5c47a7;
          color: #ffffff;
        }
      }
    }
  }
</style>
